var lang = lang || document.documentElement.lang;

(function($, d, g) {

	'use strict';
    var header;
    var popupBtn;
    var closePopupBtn;
    var closeSlideInPopupBtn;
    var siteOverlay;
    var toggleTriggerElement;
    var toggleTriggerElementOpen;
    var toggleTriggerElementClose;
    var toggleFormBtn;
    var closeToggleFormBtn;
    var tableActionPopupBtn;
    var tableActionCloseBtn;
    var closeWarningBoxBtn;
    var closeWarningBoxDefiniteBtn;
    var accordionHeader;
    var numbersOnlyInput;
	var doubleQuotePreventOnlyInput;
    var oneEventListStyle;
    var changeInputQtyBtn;
    var instructionsBoxBtn;
    var contactPopupSubmitBtn;
    var hideItemRadioBtn;
    var minOne;
    var maxHundread;
    var respDetectionSmScreen;
    
    var systemDateTime;

    var openPopup = function() {
        var t = $(this);
        var id = t.attr('id');
        if(id === undefined){
            id = t.attr("data-id");
        }
        var parentCtn = t.closest('.popup-outer-ctn');
        var popup = $('.popup#' + id);

        if (popup.hasClass('slide-in') && !$('body').hasClass('no-scroll') && respDetectionSmScreen.css('visibility') === 'visible') {
            header.toggleScroll();
        }
        
        if (popup.length !== 0) {            
            popup.addClass('open');

            if (popup.parent().closest('.popup-ctn').length === 0) {            
                if (popup.attr('data-overlay-selector-class')) {
                    parentCtn.find('.' + popup.attr('data-overlay-selector-class')).addClass('active');
                } else {
                    $('.overlay', 'body').addClass('active');
                }
            }
        }
    };

    var closePopup = function() {
        var t = $(this);
        var id = t.closest('.popup-ctn').attr('id');
        var parentCtn = t.closest('.popup-outer-ctn');
        var popup = $('.popup[id=' + id + ']');

        if (popup.length !== 0) {
            popup.removeClass('open');
            
            if (popup.hasClass('slide-in') && $('body').hasClass('no-scroll')) {
                header.toggleScroll();
            }

            if (popup.parent().closest('.popup-ctn').length === 0 || popup.hasClass('remove-overlay')) {  
                if (popup.attr('data-overlay-selector-class')) {
                    parentCtn.find('.' + popup.attr('data-overlay-selector-class')).removeClass('active');
                } else {
                    $('.overlay', 'body').removeClass('active');
                }
            }
        }
    };

    var toggleElement = function(e) {
        var t = $(this);
        var parent = t.closest('.toggle-outer-ctn');
        var element = parent.children('.element-to-toggle');
        var delay = 0;
        var delay2 = 0;

        if (element.length === 0) {
            element = $('.element-to-toggle[data-id=' + t.attr('data-id') + ']');
        }

        if (t.hasClass("sliding")) {
            e.preventDefault();
        }
        t.addClass("sliding");

        // for buttons who also have a form validation on click
        if (t.hasClass('check-errors')) {
            delay2 = 300;
        }

        setTimeout(function() {
            if ((element.find('.form-input.error').length > 0 && t.hasClass('check-errors'))) {
                return false;
            }

            element.each(function(i) {
                var oneElement = $(this);

                if (i !== 0) {
                    delay = delay + 300;
                }

                setTimeout(function() {
                    if (oneElement.hasClass('hide')) {
                        oneElement.slideDown(300, function() {
                            t.removeClass("sliding");
                            $(this).removeClass('hide');

                            if (!$(this).hasClass('no-required')) {
                                if ($('input', $(this))) {
                                    $('input', $(this)).addClass('required');
                                }
                            }
                        });

                    } else {
                        oneElement.slideUp(300, function() {
                            t.removeClass("sliding");
                            $(this).addClass('hide');

                            if (!$(this).hasClass('no-required')) {
                                if ($('input', $(this))) {
                                    $('input', $(this)).removeClass('required');
                                }
                            }
                        });
                    }
                }, delay);
            });
        }, delay2);
    };

    var openToggleElement = function(e) {
        var t = $(this);
        var parent = t.closest('.toggle-outer-ctn');
        var element = parent.children('.element-to-toggle');

        if (element.hasClass('hide')) {
            element.slideDown(300, function() {
                $(this).removeClass('hide');
                if ($('.derequired', $(this))) {
                    $('.derequired', $(this)).addClass('required');
                }
            });
        }
    };

    var closeToggleElement = function(e) {
        var t = $(this);
        var parent = t.closest('.toggle-outer-ctn');
        var element = parent.children('.element-to-toggle');

        if (!element.hasClass('hide')) {
            element.slideUp(300, function() {
                $(this).addClass('hide');
                if ($('.required', $(this))) {
                    $('.required', $(this)).removeClass('required');
                }
            });
        }
    };

    var toggleForm = function() {
        var t = $(this);
        var forward = t.attr("data-forward");
        var parent = t.closest('.toggle-form-outer-ctn');
        var selectedFormNumber = t.data('number');
        var selectedForm = parent.find('.toggle-form-ctn[data-number=' + selectedFormNumber + ']');
        var displayedForm = parent.find('.toggle-form-ctn.open');
        var displayedFormNumber = displayedForm.data('number');

        if(forward !== undefined && forward !== ''){
            window.location = forward;
        } else if (displayedFormNumber === selectedFormNumber) {
            selectedForm.removeClass('open');

            setTimeout(function() {
                selectedForm.slideUp(400);
            }, 300);
        } else if (displayedFormNumber !== selectedFormNumber && displayedFormNumber !== undefined) {
            displayedForm.removeClass('open');

            setTimeout(function() {
                displayedForm.slideUp(400);

                setTimeout(function() {
                    selectedForm.slideDown(400);

                    setTimeout(function() {
                        selectedForm.addClass('open');
                    }, 400);
                }, 400);
            }, 300);
        } else {
            selectedForm.slideDown(400);

            setTimeout(function() {
                selectedForm.addClass('open');
            }, 400);
        }
    };

    var closeToggleForm = function() {
        var t = $(this);
        var form = t.closest('.toggle-form-ctn');

        if(t.attr("data-url") !== undefined && t.attr("data-url") !== ''){
            window.location = t.attr("data-url");
        } else {
            form.removeClass('open');

            setTimeout(function () {
                form.slideUp(400);
            }, 300);
        }
    };

    var toggleActionsPopup = function() {
        var t = $(this);
        var parent = t.closest('.table-action-btns-ctn');
        var table = t.closest('table');
        var closestRow = t.closest('tr');
        var ctn = closestRow; 

        if (!closestRow.length) {
            ctn = parent; // also used for promotions page (not a table);
        }

        var rowActionButtons = ctn.find('.table-action-popup-btn');
        var actionsPopup = ctn.find('.table-actions-ctn');
            table.find('tr').each(function() {
        });
        
        var _close = function() {
            rowActionButtons.removeClass('active');
            table.find('.table-cell-overlay').fadeOut(300, function() {
                $(this).removeClass('active');
            });
            actionsPopup.removeClass('open');

            if (!parent.is('div')) {
                $('.overlay', 'body').removeClass('active-responsive');
            }
        };
        var _open = function() {
            rowActionButtons.addClass('active');
            table.find('.table-cell-overlay').fadeIn(300, function() {
                $(this).addClass('active');
            });
            setTimeout(function () {
                $("body").one("click", _close);
            }, 300);
            actionsPopup.addClass('open');

            if (!parent.is('div')) {
                $('.overlay', 'body').addClass('active-responsive');
            }
        };
        
        if (rowActionButtons.hasClass('active')) {
            _close();
        } else {
            _open();
        }
    };

    var closeActionPopup = function() {
        var t = $(this);
        var table = t.closest('table');
        var rowActionButtons = t.closest('tr').find('.table-action-popup-btn');
        var actionsPopup = t.closest('tr').find('.table-actions-ctn');
        
        rowActionButtons.removeClass('active');
        table.find('.table-cell-overlay').fadeOut(300, function() {
            $(this).removeClass('active');
        });
        actionsPopup.removeClass('open');
        $('.overlay', 'body').removeClass('active-responsive');
    };

    var closeWarningBox = function() {
        var t = $(this);
        var id = t.attr("data-id");
        
        var url = "/action/messages";
        url += "?ajax=true";
        url += "&read=true";
        url += "&id="+id;
        
        ajax(url, function(response){
            t.closest('.warning-box').slideUp(300, function() {
                t.remove();
            });   
        },true);        
    };

    var closeWarningDefiniteBox = function() {
        var t = $(this);
        var id = t.attr("data-id");
        var pageId = t.attr("data-pageid");
        
        var url = '/action/manageGenData';
        url += '?field1=warningClose';
        url += '&field2=' + id;
        url += '&field3=' + pageId;
        url += '&ajax=true';
        
        ajax(url, function(response) {
            if (response.indexOf('success') !== -1) {
                t.closest(".warning-box").slideUp();
            }
        }, true);  
    };

    var toggleAccordionContent = function() {
        var content = $(this).closest('.accordion-outer-ctn').find('.accordion-content');

        if (content.hasClass('open')) {
            content.slideUp(300);
            content.removeClass('open');
        } else {
            content.slideDown(300);
            content.addClass('open');
        }
    };

    var typeNumbersOnly = function(event) {
        if (!event.shiftKey && (event.which === 0 || event.which === 8 || event.which === 48 || event.which === 49 || event.which === 50 || event.which === 51 || event.which === 52 || event.which === 53 || event.which === 54 || event.which === 55 || event.which === 56 || event.which === 57)) {
            return true;
        } else {
            event.preventDefault();
            return false;
        }
    };
	
	
	var typePreventDoubleQuote = function(event) {
        if (event.which === 34 || event.which === 35) {
            event.preventDefault();
            return false;
        } else {
            return true;
        }
    };
    

    var openEventDetails = function(event) {
        if ($(event.target).closest('.show-more-btn').length === 0 && !$(event.target).is('a') && $(event.target).closest('.show-more-atttending-artists-event-list-popup').length === 0) {
            var url = $(this).attr('data-url');
            window.location.href = url;
        }
    };

    var changeInputQty = function() {
        var t = $(this);
        var max = t.data('max-qty') ? t.data('max-qty') : false;
        var min = t.data('min-qty') ? t.data('min-qty') : 0;
        var input = t.closest('.qty-input-with-buttons').find('.form-input');
        var val = input.val().length ? parseInt(input.val()) : 0;

        if (t.hasClass('plus') && (val < max || max === false)) {
            input.val(val += 1);
            if (input.hasClass('form-select')) {
                input.trigger('change');
            }
        } else if (t.hasClass('minus') && val > min) {
            input.val(val -= 1);
            if (input.hasClass('form-select')) {
                input.trigger('change');
            }
        }

        disableQtyBtns(t, val, min, max);
    };

    var disableQtyBtns = function(t, val, min, max) {
        var minusBtn = t.closest('.qty-input-with-buttons').find('.change-qty-btn.minus');
        var plusBtn = t.closest('.qty-input-with-buttons').find('.change-qty-btn.plus');
        
        if(plusBtn.hasClass("locked")){
            plusBtn.addClass('disabled');
            if (val !== min) {
                minusBtn.removeClass('disabled');
            }
        } else if (val === max) {
            plusBtn.addClass('disabled');
            minusBtn.removeClass('disabled');
        } else if (val === min) {
            minusBtn.addClass('disabled');
            plusBtn.removeClass('disabled');
        } else {
            plusBtn.removeClass('disabled');
            minusBtn.removeClass('disabled');
        }
    };

    var toggleInstructionsBox = function() {
        var box = $(this).closest('.instructions-box-outer-ctn').find('.instructions-box-ctn');
        box.slideToggle(300);
    };

    var submitContactForm = function() {
        var t = $(this);
        var form = t.closest('form');

        formValidator.validateForm(form);

        if (!form.hasClass('has-error')) {
            form.submit();
        }
    };

    var updateHideItemChoice = function() {
        var t = $(this);
        var key = t.attr('name');
        var allChoices = t.closest('.hide-item-settings-ctn');
        var val = '';

        allChoices.find('.form-check-input').each(function() {
            if ($(this).prop('checked') === true) {
                val += $(this).val();
            }
        });

        labels.save(key, val, 'fr', function() {
            labels.save(key, val, 'en', function() {});
        });
    };
    
    var activateSystemTimer = function() {
        try {
            systemDateTime.setTime(systemDateTime.getTime() + 1000 * 60);
            d.getElementById("systemCurrentDate").value = systemDateTime.getFullYear() + "" + formatZeros(systemDateTime.getMonth() + 1) + "" + formatZeros(systemDateTime.getDate());
            d.getElementById("systemCurrentTime").value = formatZeros(systemDateTime.getHours()) + ":" + formatZeros(systemDateTime.getMinutes());
            setTimeout(activateSystemTimer, 1000 * 60);
        } catch (err) {
            console.error(err);
        }
    };

    var minOneVal = function () {
        var t = $(this);
        if (parseFloat(t.val()) === 0 || t.hasClass('always-filled') && t.val() === '') {
            t.val(1);
        }
    };

    var maxHundreadVal = function () {
        var t = $(this);
        if (parseInt(t.val()) > 100) {
            t.val(100);
        }
    };

    var toggleTooltip = function() {
        $('.input-tooltip[data-id=' + $(this).attr('data-id') + ']').fadeToggle();
    };
    
    var sendEmail = function (email, subject, message, file, fields, callback = () => {}) {
        var params = {
            email: email,
            subject: subject,
            file: file,
        };
        if (message) {
            params.message = message;
        }
        for (var key in fields) {
            if (fields.hasOwnProperty(key) && /^field[123456]$/.test(key)) {
                params[key] = fields[key];
            }
        }
        $.ajax({
            url: "/action/sendEmail",
            method: "post",
            data: params,
            complete: function (response) {
                callback(response.responseText);
            }
        });
    };

	var init = function () {
        loadTouchEvents($);

        header = Fw.modules.models().header;
        popupBtn = $('.popup-btn');
        closePopupBtn = $('.popup-ctn .popup-inner-close');
        closeSlideInPopupBtn = $('.close-slide-in-popup-btn');
        toggleTriggerElement = $('body:not(.is-logged-in) .toggle-trigger-element, .toggle-trigger-element.exception');
        toggleTriggerElementOpen = $('body:not(.is-logged-in) .toggle-trigger-element-open');
        toggleTriggerElementClose = $('body:not(.is-logged-in) .toggle-trigger-element-close');
        toggleFormBtn = $('body:not(.is-logged-in) .toggle-form-btn');
        closeToggleFormBtn = $('body:not(.is-logged-in) .close-toggle-form-btn');
        tableActionPopupBtn = $('.table-action-popup-btn');
        tableActionCloseBtn = $('.action-popup-responsive-close-btn');
        closeWarningBoxBtn = $('.close-warning-box-btn');
        closeWarningBoxDefiniteBtn = $('.close-warning-box-definite-btn');
        accordionHeader = $('.accordion-header');
        numbersOnlyInput = $('input.numbers-only');
		doubleQuotePreventOnlyInput = $('.prevent-double-quote-only');
//        oneEventListStyle = $('.items-list-one-item-ctn.one-event');
        changeInputQtyBtn = $('.change-qty-btn');
        instructionsBoxBtn = $('.instructions-box-btn');
        contactPopupSubmitBtn = $('.contact-popup-submit-btn');
        hideItemRadioBtn = $('.hide-item-radio-btn');
        minOne = $('input.min-one');
        maxHundread = $('input.max-hundread');
        respDetectionSmScreen = $('.responsive-detector-sm');

        popupBtn.click(openPopup);
        closePopupBtn.click(closePopup);
        closeSlideInPopupBtn.click(closePopup);
        toggleTriggerElement.click(toggleElement);
        toggleTriggerElementOpen.click(openToggleElement);
        toggleTriggerElementClose.click(closeToggleElement);
        toggleFormBtn.click(toggleForm);
        closeToggleFormBtn.click(closeToggleForm);
        tableActionPopupBtn.click(toggleActionsPopup);
        closeWarningBoxBtn.click(closeWarningBox);
        closeWarningBoxDefiniteBtn.click(closeWarningDefiniteBox);
        accordionHeader.click(toggleAccordionContent);
        tableActionCloseBtn.click(closeActionPopup);
        numbersOnlyInput.keypress(typeNumbersOnly);
		doubleQuotePreventOnlyInput.keypress(typePreventDoubleQuote);
//        oneEventListStyle.click(openEventDetails);
        changeInputQtyBtn.click(changeInputQty);
        instructionsBoxBtn.click(toggleInstructionsBox);
        contactPopupSubmitBtn.click(submitContactForm);
        hideItemRadioBtn.change(updateHideItemChoice);
        minOne.keyup(minOneVal);
        maxHundread.keyup(maxHundreadVal);
        $('body.is-admin .input-tooltip-btn').click(toggleTooltip);
        
        $("input.float-number").keypress(numLockFloat);
        
        if (d.getElementById("systemCurrentDate") && d.getElementById("systemCurrentTime")) {
            var sysCurDate = d.getElementById("systemCurrentDate").value;
            var sysCurTime = d.getElementById("systemCurrentTime").value;
            sysCurDate = sysCurDate.substr(0, 4) + "/" + sysCurDate.substr(4, 2) + "/" + sysCurDate.substr(6, 2);
            systemDateTime = new Date(sysCurDate + " " + sysCurTime);
            setTimeout(activateSystemTimer, 1000 * 60);
        }
	};

	var tools = Fw.component.export('tools', {
		init: init,
        disableQtyBtns: disableQtyBtns,
        sendEmail: sendEmail
	});

})(jQuery, document, window);

function formatDecimal(n, d) {
    if (isNaN(n) || (n - Math.floor(n)).length - 2 <= d) {
        return n;
    }
    var r = Math.pow(10, isNaN(d) ? 2 : d);
    return Math.round(n * r) / r;
}
function formatDecimal2(n, d) {
    var d2 = isNaN(d) ? 2 : d;
    return formatDecimal(formatDecimal(n, d2 + 1), d2);
}
function formatMoney($, round) {
    var lang = document.documentElement.lang,
        dec = round ? 0 : 2,
        x = isNaN($) ? parseFloat($.replace(",", ".")) : parseFloat($),
        res = x.toFixed(dec).toString();

    return (lang === "en") ? "$" + res : res.replace(".", ",") + "$";
}
function formatZeros(n, l) {
    var str = n.toString();
    var nl = str.length;
    l = l || 2;
    while (nl < l) {
        str = "0" + str;
        nl++;
    }
    return str;
}
function getIntDateTime(y, m, d, h, mn) {
    var dt = getDateYMD(y, m, d) + formatZeros(h) + formatZeros(mn);
    return parseInt(dt);
}
function getDateYMD(y, m, d, a) {
    var im = parseInt(m) + 1;
    var array = [y, formatZeros(im), formatZeros(d)];
    return array.join(a ? a : "");
}
function getTimeHMS(h, m, s, a1, a2) {
    if (s === undefined || s === null || s === "") {
        return formatZeros(h) + (a1 ? a1 : "") + formatZeros(m);
    } else {
        return formatZeros(h) + (a1 ? a1 : "") + formatZeros(m) + (a2 ? a2 : "") + formatZeros(s);
    }
}
function getDatePrefix(o, prefix) {
    return getDateFormatted(o[prefix + "DateYear"], o[prefix + "DateMonth"], o[prefix + "DateDay"]);
}
function getTimePrefix(o, prefix) {
    return getTimeFormatted(o[prefix + "DateHour"], o[prefix + "DateMinute"]);
}
function getDateFormatted(y, m, d) {
    var om = {"en": ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"], "fr": ["janvier", "f\xE9vrier", "mars", "avril", "mai", "juin", "juillet", "ao\xFBt", "septembre", "octobre", "novembre", "decembre"]};
    var im = parseInt(m);
    switch (lang) {
        case "fr": return d + " " + om[lang][im] + " " + y;
        case "en": return om[lang][im] + " " + d + " " + y;
        default: return y + "-" + (im + 1) + "-" + d;
    }
}
function getTimeFormatted(t) {
    var a = [];
    var tf = "";
    if (lang === "fr") {
        if (t.match("h")) {
            tf = t;
        } else {
            a = t.split(":");
            tf = a[0] + "h" + a[1];
            if (a.length > 2) tf += "m" + a[2] + "s";
        }
    } else {
        if (t.match(":")) {
            tf = t;
        } else {
            var ih = t.search(/h/i);
            a[0] = t.substring(0, ih);
            a[1] = t.subtring(ih + 1);
            var im = t.search(/m/i);
            if (im > -1) {
                a[1] = t.substring(ih + 1, im);
                a[2] = t.substring(im + 1, t.length - 1);
            }
            tf = a.join(":");
        }
    }
    return tf;
}
function parseFormattedDate(date, sep) {
    var a = date.split(" "),
        d = isNaN(parseInt(a[0])) ? a[1] : a[0],
        m = isNaN(parseInt(a[0])) ? a[0] : a[1],
        y = a[2];
    
    return getDateYMD(y, parseMonthSystem(m), d, sep);
}
function parseMonthSystem(str) {
    var list = ["january", "february", "march", "april", "may", "june", "july", "august", "september", "october", "november", "december"];
    if (lang === "fr") {
        list = ["janvier", "f\xE9vrier", "mars", "avril", "mai", "juin", "juillet", "ao\xFBt", "septembre", "octobre", "novembre", "decembre"];
    }
    return list.indexOf(str.toLowerCase());
}
function roundUpTime(time) {
    var c = time.split(":"),
        h = parseInt(c[0]),
        m = parseInt(c[1]);

    m = (m - m % 15) + 15;
    if (m >= 60) {
        m = 0;
        h++;
    }
    return formatZeros(h % 24) + ":" + formatZeros(m);
}
function roundTime(time, rounder) {
    var d = time.match(/[h:]/),
        c = time.split(d),
        r = rounder ? rounder : 15,
        m = Math.round(parseInt(c[1]) / r) * r,
        h = parseInt(c[0]) + Math.floor(m / 60);

    return formatZeros(h % 24) + d + formatZeros(m % 60);
}

function encodeText(name) {
    name = name.replace(/\\xE0/g, '\xE0');
    name = name.replace(/\\xE2/g, '\xE2');
    name = name.replace(/\\xE3/g, '\xE3');
    name = name.replace(/\\xE4/g, '\xE4');
    name = name.replace(/\\xE5/g, '\xE5');
    name = name.replace(/\\xE7/g, '\xE7');
    name = name.replace(/\\xE9/g, '\xE9');
    name = name.replace(/\\xE8/g, '\xE8');
    name = name.replace(/\\xEA/g, '\xEA');
    name = name.replace(/\\xEB/g, '\xEB');
    name = name.replace(/\\xEE/g, '\xEE');
    name = name.replace(/\\xEF/g, '\xEF');
    name = name.replace(/\\xF1/g, '\xF1');
    name = name.replace(/\\xF2/g, '\xF2');
    name = name.replace(/\\xF3/g, '\xF3');
    name = name.replace(/\\xF4/g, '\xF4');
    name = name.replace(/\\xF6/g, '\xF6');
    name = name.replace(/\\xF9/g, '\xF9');
    name = name.replace(/\\xFB/g, '\xFB');
    name = name.replace(/\\xC0/g, '\xC0');
    name = name.replace(/\\xC2/g, '\xC2');
    name = name.replace(/\\xC7/g, '\xC7');
    name = name.replace(/\\xC8/g, '\xC8');
    name = name.replace(/\\xC9/g, '\xC9');
    name = name.replace(/\\xCA/g, '\xCA');
    name = name.replace(/\\xCB/g, '\xCB');
    name = name.replace(/\\xCE/g, '\xCE');
    name = name.replace(/\\xCF/g, '\xCF');
    name = name.replace(/\\xD1/g, '\xD1');
    name = name.replace(/\\xD4/g, '\xD4');
    name = name.replace(/\\xD9/g, '\xD9');
    name = name.replace(/\\xDB/g, '\xDB');
    return name;
}

function encodeInputText(name) {
    name = name.replace('Ã ', '\xE0');
    name = name.replace('Ã¢', '\xE2');
    name = name.replace('Ã£', '\xE3');
    name = name.replace('Ã¤', '\xE4');
    name = name.replace('Ã¥', '\xE5');
    name = name.replace('Ã§', '\xE7');
    name = name.replace('Ã©', '\xE9');
    name = name.replace('Ã¨', '\xE8');
    name = name.replace('Ãª', '\xEA');
    name = name.replace('Ã«', '\xEB');
    name = name.replace('Ã®', '\xEE');
    name = name.replace('Ã¯', '\xEF');
    name = name.replace('Ã±', '\xF1');
    name = name.replace('Ã²', '\xF2');
    name = name.replace('Ã³', '\xF3');
    name = name.replace('Ã´', '\xF4');
    name = name.replace('Ã¶', '\xF6');
    name = name.replace('Ã¹', '\xF9');
    name = name.replace('Ã»', '\xFB');
    name = name.replace('Ã€', '\xC0');
    name = name.replace('Ã‚', '\xC2');
    name = name.replace('Ã‡', '\xC7');
    name = name.replace('Ãˆ', '\xC8');
    name = name.replace('Ã‰', '\xC9');
    name = name.replace('ÃŠ', '\xCA');
    name = name.replace('Ã‹', '\xCB');
    name = name.replace('ÃŽ', '\xCE');
    name = name.replace('Ã?', '\xCF');
    name = name.replace('Ã’', '\xD1');
    name = name.replace('Ã�?', '\xD4');
    name = name.replace('Ã™', '\xD9');
    name = name.replace('Ã›', '\xDB');
    return name;
}

function pageScrlTo(pos) {
    $("html, body").animate({scrollTop: pos});
}

function newXHR() {
    var xhr;
    if (window.XMLHttpRequest) {
        xhr = new XMLHttpRequest();
    } else {
        try {
            xhr = new ActiveXObject("Msxml2.XMLHTTP");
        } catch (e) {
            try {
                xhr = new ActiveXObject("Microsoft.XMLHTTP");
            } catch (e) {
                return null;
            }
        }
    }
    return xhr;
}
function siteAjax(url, callback, returnVar, blackout) {
    var xhr = newXHR();
    if (!xhr) return;
    if (blackout) ajaxBlackout(true);
    var noCache = "cache=" + Math.random();
    var nonCacheUrl = url + (url.indexOf("?") > -1 ? "&" : "?") + noCache;
    xhr.open("GET", nonCacheUrl, true);
    xhr.onreadystatechange = function() {
        if (this.readyState == 4) {
            if (this.status == 200) {
                if (callback) {
                    var res = this.responseText;
                    callback(res, returnVar);
                }
            } else {
                console.error(this.statusText);
                popErrorSite('errorMessageAjaxSite');
                document.getElementById('errorMessageAjaxSite').innerHTML = 
                    "Error " + this.status + "! Sending request failed.";
            }
            if (blackout) ajaxBlackout(false);
        }
    };
    xhr.send(null);
}
function siteAjaxFile(oFormElement, callback) {
    var success = false;
    
    function ajaxSuccess(response) {
        success = true;
        callback(response);
    }
    function ajaxError(status) {
        console.error(status);
        popErrorSite('errorMessageAjaxSite');
        document.getElementById('errorMessageAjaxSite').innerHTML = 
            "Error " + status + "! Sending request failed.";
    }
    function ajaxComplete() {
        if (this.status === 200 && this.statusText === "OK") {
            ajaxSuccess(this.responseText);
        } else {
            ajaxError(this.status);
        }
    }
    function submitData(oData) {
        var oAjaxReq = new XMLHttpRequest();
        oAjaxReq.submittedData = oData;
        oAjaxReq.onload = ajaxComplete;
        oAjaxReq.open("post", oData.receiver, true);
        if (oData.technique === 3) {
            var sBoundary = "---------------------------" + Date.now().toString(16);
            oAjaxReq.setRequestHeader("Content-Type", "multipart\/form-data; boundary=" + sBoundary);
            oAjaxReq.sendAsBinary("--" + sBoundary + "\r\n" + oData.segments.join("--" + sBoundary + "\r\n") + "--" + sBoundary + "--\r\n");
        } else {
            oAjaxReq.setRequestHeader("Content-Type", oData.contentType);
            oAjaxReq.send(oData.segments.join(oData.technique === 2 ? "\r\n" : "&"));
        }
    }
    function processStatus(oData) {
        if (oData.status > 0) {
            return;
        }
        submitData(oData);
    }
    function pushSegment(oFREvt) {
        this.owner.segments[this.segmentIdx] += oFREvt.target.result + "\r\n";
        this.owner.status--;
        processStatus(this.owner);
    }
    function plainEscape(sText) {
        return sText.replace(/[\s\=\\]/g, "\\$&");
    }
    function SubmitRequest(oTarget) {
        var nFile, sFieldType, oField, oSegmReq, oFile, bIsPost = oTarget.method.toLowerCase() === "post";
        this.contentType = bIsPost && oTarget.enctype ? oTarget.enctype : "application\/x-www-form-urlencoded";
        this.technique = bIsPost ? this.contentType === "multipart\/form-data" ? 3 : this.contentType === "text\/plain" ? 2 : 1 : 0;
        this.receiver = oTarget.action;
        this.status = 0;
        this.segments = [];
        var fFilter = this.technique === 2 ? plainEscape : escape;
        for (var nItem = 0; nItem < oTarget.elements.length; nItem++) {
            oField = oTarget.elements[nItem];
            if (!oField.hasAttribute("name") && oField.name !== "") {
                continue;
            }
            sFieldType = oField.nodeName.toUpperCase() === "INPUT" ? oField.getAttribute("type").toUpperCase() : "TEXT";
            if (sFieldType === "FILE" && oField.files.length > 0) {
                if (this.technique === 3) {
                    for (nFile = 0; nFile < oField.files.length; nFile++) {
                        oFile = oField.files[nFile];
                        oSegmReq = new FileReader();
                        oSegmReq.segmentIdx = this.segments.length;
                        oSegmReq.owner = this;
                        oSegmReq.onload = pushSegment;
                        this.segments.push("Content-Disposition: form-data; name=\"" + oField.name + "\"; filename=\"" + oFile.name + "\"\r\nContent-Type: " + oFile.type + "\r\n\r\n");
                        this.status++;
                        oSegmReq.readAsBinaryString(oFile);
                    }
                } else {
                    for (nFile = 0; nFile < oField.files.length; this.segments.push(fFilter(oField.name) + "=" + fFilter(oField.files[nFile++].name)));
                }
            } 
            else if ((sFieldType !== "RADIO" && sFieldType !== "CHECKBOX") || oField.checked) {
                this.segments.push(
                        this.technique === 3 ? 
                        "Content-Disposition: form-data; name=\"" + oField.name + "\"\r\n\r\n" + oField.value + "\r\n"
                        :
                        fFilter(oField.name) + "=" + fFilter(oField.value)
                        );
            }
        }
        processStatus(this);
    }
    
    new SubmitRequest(oFormElement);
}
function keepAlive(loop, time) {
    siteAjax('/action/keepAlive', function() {
        if (loop) setTimeout(function() {keepAlive(loop, time);}, time ? time : 15 * 60000);
    });
}

function triggerInputFocus(q, v, eventToTrigger) {
    var $e = $(q);
    if (v !== undefined && v !== null) {
        $e.val(v);
    }
    if ($e.val()!=null && $e.val().trim().length > 0) {
        $e.closest(".input-ctn").addClass("focused");
    } else {
        $e.closest(".input-ctn").removeClass("focused");
    }
    if (eventToTrigger) {
        $e.trigger(eventToTrigger);
    }
}

function getDataSet(el) {
    var map = {};
    if (!el.dataset) {
        var as = el.attributes;
        var tuc = function(x, y) {return y.toUpperCase();};
        for (var i = 0; i < as.length; i++) {
            var a = as[i];
            var n = a.name;
            var m = n.match(/^data-(.+)/);
            if (m) map[m[1].replace(/\-([a-z])/ig, tuc)] = a.value;
        }
    } else {
        map = el.dataset;
    }
    return map;
}

function jsonEscape(str) {
    // Ref. http://json.org/
    return str.replace(/\0/g, "")
        .replace(/\\/g, "\\\\")
        .replace(/\//g, "\\/")
        .replace(/\n/g, "\\n")
        .replace(/\f/g, "\\f")
        .replace(/\r/g, "\\r")
        .replace(/\t/g, "\\t")
        .replace(/\v/g, "\\v");
}


function numLockFloat(e) {
    var k = e.which || e.keyCode || e.charCode;
    // Allow: BACKSPACE, TAB, ESCAPE, END, HOME, ARROWS, ., DELETE, NUMLOCK
    if ([0, 8, 9, 27, 35, 36, 37, 38, 39, 40, 46, 110, 144, 190].indexOf(k) > -1
    // Allow: Ctrl+A, Ctrl+C, Ctrl+X, Ctrl+V, Ctrl+Z, Ctrl+Y
        || [65, 67, 86, 88, 89, 90].indexOf(k) > -1 && (e.ctrlKey || e.metaKey)) {
        // Prevent more than 1 decimal point
        if ([110, 190].indexOf(k) > -1 && this.value.match(/\./)
        // keypress single quote is 39 and n is 110
            || [39, 110].indexOf(k) > -1 && e.type === "keypress") {
            e.preventDefault();
        } else {
            return;
        }
    }
    // Ensure that it is a number and stop the keypress
    if ((e.shiftKey || (k < 48 || k > 57)) &&
        ((k < 96 || k > 105) || e.type === "keypress")) {
        e.preventDefault();
    }
}